'use client';
import { ReactNode } from 'react';
import Image from 'next/image';

type Props = {
    image: 'categories' | 'recommended' | 'recommended-default' | 'diseases';
    heading: string;
    description?: ReactNode;
    extra?: ReactNode;
};

export default function TestsBanner({ image, heading, description = null, extra = null }: Props) {
    return (
        <section className="relative text-lg text-white">
            <Image
                src={`/images/tests/banner-${image}.jpg`}
                alt={heading}
                className="absolute -z-10 object-cover"
                fill
                sizes="100vw"
                priority
            />

            <div className="container mx-auto flex min-h-[300px] items-center justify-between p-4 py-10 md:min-h-[400px]">
                <div className="w-2/3 md:w-1/2 lg:w-2/5">
                    <h1 className={`mb-10 ${image === 'categories' ? 'text-5xl' : 'text-3xl'} md:text-6xl xl:text-7xl`}>
                        {heading}
                    </h1>
                    {description && <div className="hidden md:block">{description}</div>}
                </div>
                {extra && <div className="flex w-1/3 justify-center md:w-1/2 lg:w-2/5">{extra}</div>}
            </div>
        </section>
    );
}
